/**
 * EventLocation component for displaying event location information
 */

import { MapPin } from 'lucide-react';

interface EventLocationProps {
  /**
   * Location string to display
   */
  location: string;
  /**
   * Variant for different display contexts
   */
  variant?: 'default' | 'overlay';
}

/**
 * EventLocation component displays event location information
 */
export function EventLocation({ location, variant = 'default' }: EventLocationProps) {
  if (variant === 'overlay') {
    return (
      <div className="flex items-center gap-2">
        <MapPin className="h-5 w-5" />
        <span className="text-sm font-medium text-foreground line-clamp-1">{location}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <MapPin className="h-5 w-5 text-primary" />
      </div>

      <div className="font-medium">{location}</div>
    </div>
  );
}
